<template>
  <div class="no_history" v-if="props.historySequence?.length == 0">
    <p>Aquí se visualizará el historial de secuencias</p>
  </div>
  <div v-else>
    <h1 class="text-center">Historial</h1>
    <h3>{{ record.fullName }}</h3>
    <span>Empresa: {{ record.entity_name }}</span
    ><br />
    <span>Campaña: {{ record.portfolio_name }}</span>
    <a-divider style="margin: 15px 0" />
    <a-card class="sequence-selected__card" v-for="item in props.historySequence">
      <span class="detail_header">
        <h3 style="margin-bottom: 0">{{ item.sequence_name }}</h3>
        <div>
          <a-tag :color="item?.sequence_status === SequenceStatus.Active ? 'green' : undefined">
            {{ item?.sequence_status === SequenceStatus.Active ? "Activa" : "Inactiva" }}
          </a-tag>
        </div>
      </span>
      <span>ID: {{ item.sequence_id }}</span>
      <a-divider style="margin: 10px 0" />
      <div class="detail_section">
        <span>Último estado del contacto en la secuencia: </span>
        <span class="detail_text"> {{ getSequenceState(item.state) }}</span
        ><br />
      </div>
      <div class="detail_section">
        <span>Último nodo interactuado: </span>
        <component v-if="item.last_node && item.last_node != {}" :is="IconByType[item.last_node.type]" class="icon" />
        <span class="detail_text" v-if="item.last_node && item.last_node != {}">
          {{ item.last_node.title ? " " + item.last_node.title : "-" }}</span
        ><br />
      </div>
      <div class="detail_section">
        <span>Asignado a secuencia por: </span>
        <span class="detail_text"> {{ item.assigned_by }}</span
        ><br />
      </div>
      <div class="detail_section">
        <span>Fecha de asignación a la secuencia: </span>
        <span class="detail_text"> {{ formatDate(item.assigned_at) }}</span
        ><br />
      </div>
    </a-card>
  </div>
</template>

<script setup lang="ts">
import { SequenceStatus, SequenceState } from "@/@types/flows/sequences";
import { humanDateWithSlashFormat } from "@/app/shared/utils/constants";
import { dateToString } from "@/app/shared/utils/dates";
import { IconByType } from "@/app/flows/sequences/utils/icons";
import { SequenceStateText } from "@/app/flows/sequences/utils/texts.ts";

const props = withDefaults(
  defineProps<{
    record: {
      id: number;
      fullName: string;
      entity_name: string;
      portfolio_name: string;
      portfolio: string;
    };
    historySequence: any;
  }>(),
  {
    record: {
      id: null,
      fullName: "",
      entity_name: "",
      portfolio_name: "",
      portfolio: "",
    },
    historySequence: null,
  }
);
const formatDate = (date: string) => {
  return dateToString(date, humanDateWithSlashFormat);
};
const getSequenceState = (State: SequenceState | undefined) => {
  if (!State) return "desconocido";
  return SequenceStateText[State];
};
</script>

<style lang="sass" scoped>
.no_history
  height: 100%
  display: flex
  justify-content: center
  align-items: center
  font-style: italic
  color: $gray-7
  font-size: 16px

.text-center
  text-align: center

.divider
  margin: 10px 0

.detail_text
  color: $gray-7

.detail_header
    width: 100%
    display: flex
    justify-content: space-between

.detail_section
  margin-top: 6px

.sequence-selected
  margin-top: 10px
  &__card
    margin-bottom: 15px
    :deep(.ant-card)
      margin-bottom: 10px
    :deep(.ant-card-body)
      padding: 15px
</style>
